const NEW_FRONTEND_BASE_PATH = "/portal";
const NEW_FRONTEND_DEV_PORT = "8211";
// 旧前端单独跑时，浏览器看到的端口不是站点统一入口。
// 3000 是本机直接启动；8210 是容器映射到宿主机。这两种都要打开新前端自己的开发端口。
const STANDALONE_OLD_FRONTEND_DEV_PORTS = new Set(["3000", "8210"]);

export function resolveNewFrontendHref(path) {
    const configuredBaseUrl = process.env.REACT_APP_NEW_FRONTEND_BASE_URL;

    if (configuredBaseUrl) {
        return `${configuredBaseUrl.replace(/\/$/, "")}${path}`;
    }

    if (typeof window !== "undefined" && STANDALONE_OLD_FRONTEND_DEV_PORTS.has(window.location.port)) {
        return `${window.location.protocol}//${window.location.hostname}:${NEW_FRONTEND_DEV_PORT}${NEW_FRONTEND_BASE_PATH}${path}`;
    }

    return `${NEW_FRONTEND_BASE_PATH}${path}`;
}
